import api from './api';
import { DETAIL_ANSWERS } from '../config/Config';

export const detailAnswerService = {
  // Get all detail answers
  getAll: async (params = {}) => {
    const response = await api.get(DETAIL_ANSWERS, { params });
    return response.data;
  },

  // Get detail answer by ID
  getById: async (id) => {
    const response = await api.get(`${DETAIL_ANSWERS}${id}/`);
    return response.data;
  },

  // Get detail answer by question ID
  getByQuestionId: async (questionId) => {
    const response = await api.get(DETAIL_ANSWERS, { 
      params: { question_id: questionId } 
    });
    // Handle both paginated and non-paginated responses
    const data = response.data;
    if (data && data.results && Array.isArray(data.results)) {
      return data.results; // Return the results array from paginated response
    }
    return data; // Return the data directly if not paginated
  },

  // Create new detail answer
  create: async (data) => {
    const response = await api.post(DETAIL_ANSWERS, data);
    return response.data;
  },

  // Update existing detail answer
  update: async (id, data) => {
    const response = await api.patch(`${DETAIL_ANSWERS}${id}/`, data);
    return response.data;
  },

  // Delete detail answer
  delete: async (id) => {
    await api.delete(`${DETAIL_ANSWERS}${id}/`);
  },

  // Upload answer image
  uploadImage: async (id, imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    
    const response = await api.post(
      `${DETAIL_ANSWERS}${id}/upload_image/`, 
      formData, 
      { 
        headers: { 'Content-Type': 'multipart/form-data' } 
      }
    );
    return response.data;
  }
};
